<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item>售后管理</el-breadcrumb-item>
		</el-breadcrumb>
		<el-form :inline="true" :model="item" class="search">
			<el-row>
				<el-form-item label="处理状态">
					<el-radio-group v-model="item.status" @change="submit">
						<el-radio-button label="0">全部</el-radio-button>
						<el-radio-button label="1">进行中</el-radio-button>
						<el-radio-button label="11">已拒绝</el-radio-button>
						<el-radio-button label="21">已完成</el-radio-button>
						<el-radio-button label="31">已取消</el-radio-button>
					</el-radio-group>
				</el-form-item>
			</el-row>
			<el-row>
				<el-form-item label="订单号">
					<el-input v-model="item.order_sn" placeholder="请输入订单号" size="small"></el-input>
				</el-form-item>
				<el-form-item label="用户">
					<el-input v-model="item.buyer_name" placeholder="请输入昵称、手机号" size="small"></el-input>
				</el-form-item>
				<el-form-item label="时间">
					<el-date-picker size="small" style="margin-left: 10px" v-model="item.times" type="daterange"
									range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss">
					</el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="submit" size="medium">查询</el-button>
				</el-form-item>
			</el-row>
		</el-form>
		<el-table :data="list" border>
			<el-table-column prop="id" label="ID"></el-table-column>
			<el-table-column label="订单号" width="250">
				<template slot-scope="scope">
					<span>{{scope.row.orderMaster ? scope.row.orderMaster.order_sn : ''}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="real_name" label="用户" width="120">
				<template slot-scope="scope">

					<div class="avatar" v-if="scope.row.user">
						<img :src="scope.row.user.avatar" />
						{{scope.row.user.nick_name}}
					</div>
				</template>
			</el-table-column>
			<el-table-column label="商品">
				<template slot-scope="scope">
					<div class="thumb" v-if="scope.row.orderGoods">
						<img :src="scope.row.orderGoods.pic_url" />
						{{scope.row.orderGoods.product_name}}
					</div>
				</template>
			</el-table-column>
			<el-table-column label="类型">
				<template slot-scope="scope">
					<template v-if="scope.row.type == 1">换货</template>
					<template v-else-if="scope.row.type == 2">退货退款</template>
				</template>
			</el-table-column>
			<el-table-column label="付款金额">
				<template slot-scope="scope">
					{{scope.row.orderGoods.total_fee}} 元
				</template>
			</el-table-column>
			<el-table-column label="退款金额">
				<template slot-scope="scope">
					<el-tag size="small" v-if="scope.row.refund_money > 0">{{scope.row.refund_money}} 元</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="name" label="状态">
				<template slot-scope="scope">
					<el-tag size="small" effect="dark" type="danger" v-if="scope.row.status == 0">进行中</el-tag>
					<el-tag size="small" effect="dark" type="warning" v-else-if="scope.row.status == 10">已拒绝</el-tag>
					<el-tag size="small" effect="dark" v-else-if="scope.row.status == 20">已完成</el-tag>
					<el-tag size="small" effect="dark" type="warning" v-else-if="scope.row.status == 30">已取消</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="created_date" label="时间"></el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button size="mini" type="primary" @click="edit(scope.row.id)">查看</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page" :page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
	</div>
</template>
<script>
export default {
	data() {
		return {
			list: [],
			isLoad: false,
			pageSize: 20,
			page: 1,
			total: 0,
			item: {
				status: '1'
			}
		}
	},
	created() {
		this.loadList();
	},
	methods: {
		// 搜索查询
		submit() {
			this.page = 1
			this.loadList()
		},
		loadList() {
			this.isLoad = !this.isLoad
			this.axios.get('store/order.refund/list',{params:Object.assign({
					page:this.page,
					pagesize:this.pageSize
				}, this.item)}).then(res => {
				this.isLoad = !this.isLoad
				this.list = res.data.list.data
				this.total = res.data.list.total
			}).catch(() => {
				this.isLoad = !this.isLoad
			})
		},
		sizeReload(val) {
			this.page = 1
			this.pageSize = val
			this.loadList()
		},
		pageReload(val) {
			this.page = val
			this.loadList()
		},
		edit(id) {
			this.$router.push({
				path: '/Refund/edit.html',
				query: {
					id: id
				}
			});
		},
		add() {
			this.$router.push({
				path: '/User/edit.html'
			});
		}
	}
}
</script>
<style scoped>
</style>
